<template>
  <div>
    <div v-if='!inResolve'>
      <v-breadcrumbs divider=">" class="px-0 pt-0 breadcrumbs">
        <v-breadcrumbs-item
          v-for="item in navSettingsOptions"
          :key="item.index"
          @click='() => {
            if (item.to) $router.push(item.to)
          }'
          :class='[
            item.to ? "cursor-pointer" : "cursor-default"
          ]'
        >
          <span
            class="text-breadcum-settings"
          >
            {{ item.text }}
            <v-icon style="font-size: 1.2rem">mdi-chevron-right</v-icon>
          </span>
        </v-breadcrumbs-item>
      </v-breadcrumbs>
      <v-card class='integration__sync__stepper'>
        <div class='integration__sync__stepper__header'>
          <h6 class='font-weight-bold' style='color: #7671bd'>Synchronization Errors</h6>
        </div>
        <v-card-text>
          <v-row>
            <v-col class='flex justify-center'>
              <img src='@/assets/icons/svg/error-color.svg' style='max-width: 80px' />
            </v-col>
          </v-row>
          <v-row>
            <v-col class='flex align-center flex-column'>
              <h6 class='font-weight-bold' style='color: #6b0302'>Error sync of the "Smarttech" warehouse with QuickBooks!</h6>
              <p class='font-weight-bold text-grey-14' style='font-size: 1.1rem'>Please resolve the ({{conflicts.length}}) conflict below to complete the sync:</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols='auto'>
              <v-btn
                color='transparent'
                depressed
                @click='takeAllTypedItems("source")'
              >
                <v-icon color='#00992b'>mdi-check</v-icon>
                <span style='color: #00992b; text-decoration: underline; text-transform: none;'>take all items from QuickBooks</span>
              </v-btn>
            </v-col>
            <v-col cols='auto' class='mx-auto'>
              <v-btn
                :color='resolved.length !== conflicts.length ? "#d3d3d3" : "#7972c0"'
                depressed
                :class='[resolved.length !== conflicts.length ? "cursor-not-allowed" : "cursor-pointer"]'
                @click='doResolve'
              >
                <span :class='[
                  resolved.length !== conflicts.length ? "text-black" : "text-white"
                ]'>
                  Resolve Conflict ({{resolved.length}} of {{conflicts.length}})
                </span>
              </v-btn>
            </v-col>
            <v-col cols='auto'>
              <v-btn
                color='transparent'
                depressed
                @click='takeAllTypedItems("target")'
              >
                <v-icon color='#00992b'>mdi-check</v-icon>
                <span style='color: #00992b; text-decoration: underline; text-transform: none;'>take all items from BriteCheck</span>
              </v-btn>
            </v-col>
          </v-row>
          <v-row class='mt-4 px-5'>
            <v-col>
              <div class='relative-position'>
                <span class='resolveErrorName'>Duplicate Item Name</span>
                <v-divider />
              </div>
            </v-col>
          </v-row>
          <div class='scroll-y' style='max-height: 60vh'>
            <v-card class='resolveItem mt-6 mx-5' v-for='(item, index) of conflicts' :key='index'>
              <v-container>
                <v-row>
                  <v-col
                    cols='6'
                    :class='[itemBg(index, "source"), "resolveItemVariant"]'
                    :key='"source"'
                  >
                    <p class='font-weight-black text-black' style='font-size: 1.2rem'>QuickBooks</p>
                    <v-row>
                      <v-col cols='auto'>
                        <v-img
                          v-if='!item.source.images.length'
                          lazy-src='@/assets/images/trolley-cart.png'
                          src='@/assets/images/trolley-cart.png'
                          max-width='60'
                        />
                        <v-img
                          v-else
                          :lazy-src='item.source.images[0]'
                          :src='item.source.images[0]'
                          max-width='60'
                        />
                      </v-col>
                      <v-col cols='auto'>
                        <p class='font-weight-bold text-black mb-0' style='font-size: 1rem;'>{{item.source.name}}</p>
                        <p class='mb-0' style='font-size: 1rem;'>Item</p>
                      </v-col>
                      <v-spacer />
                      <v-col cols='auto'>
                        <p class='font-weight-bold text-grey-8 mb-0' style='font-size: 1rem;'>Quantity</p>
                        <p class='mb-0' style='font-size: 1rem; text-align: right;'>{{ item.source.quantity | formattedNumber }}</p>
                      </v-col>
                    </v-row>
                    <v-row class='mt-0'>
                      <v-col cols='7'>
                        <p class='mb-0'>{{item.source.description}}</p>
                      </v-col>
                      <v-spacer />
                      <v-col cols='auto'>
                        <v-btn
                          color='transparent'
                          depressed
                          @click='takeItem(index, "source")'
                        >
                          <v-icon color='#00992b'>mdi-check</v-icon>
                          <span style='color: #00992b; text-decoration: underline; text-transform: none;'>take this item</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols='6'
                    :class='[itemBg(index, "target"), "resolveItemVariant"]'
                    :key='"target"'
                  >
                    <p class='font-weight-black text-black' style='font-size: 1.2rem'>Britecheck: <span style='color: #7972c0'>{{integrationInfo.warehouse.name}}</span></p>
                    <v-row>
                      <v-col cols='auto'>
                        <v-img
                          v-if='!item.target.images.length'
                          lazy-src='@/assets/images/trolley-cart.png'
                          src='@/assets/images/trolley-cart.png'
                          max-width='60'
                        />
                        <v-img
                          v-else
                          :lazy-src='item.target.images[0]'
                          :src='item.target.images[0]'
                          max-width='60'
                        />
                      </v-col>
                      <v-col cols='auto'>
                        <p class='font-weight-bold text-black mb-0' style='font-size: 1rem;'>{{item.target.name}}</p>
                        <p class='mb-0' style='font-size: 1rem;'>Item</p>
                      </v-col>
                      <v-spacer />
                      <v-col cols='auto'>
                        <p class='font-weight-bold text-grey-8 mb-0' style='font-size: 1rem;'>Quantity</p>
                        <p class='mb-0' style='font-size: 1rem; text-align: right;'>{{ item.target.quantity | formattedNumber }}</p>
                      </v-col>
                    </v-row>
                    <v-row class='mt-0'>
                      <v-col cols='7'>
                        <p class='mb-0'>{{item.target.description}}</p>
                      </v-col>
                      <v-spacer />
                      <v-col cols='auto'>
                        <v-btn
                          color='transparent'
                          depressed
                          @click='takeItem(index, "target")'
                        >
                          <v-icon color='#00992b'>mdi-check</v-icon>
                          <span style='color: #00992b; text-decoration: underline; text-transform: none;'>take this item</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <div v-else>
      <v-row class='mt-6'>
        <v-col class='flex justify-center'>
          <h6 class='font-weight-bold'>The conflicts resolving in progress...</h6>
        </v-col>
      </v-row>
      <v-row class='mt-4'>
        <v-col class='flex justify-center'>
          <div class='relative-position mb-6' style='height: 48px'>
            <custom-circle-progress-bar />
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import service from '@/services/integrations'
import { mapGetters } from 'vuex'
import CustomCircleProgressBar from '@/components/CustomCircleProgressBar'

function findItemInResolved(item) {
  return this.resolved.findIndex(resolvedItem => resolvedItem.id === item.id)
}
function haveTypedItemInResolved(item, type) {
  const findedIndex = findItemInResolved.call(this, item)
  if (findedIndex >= 0) {
    if (this.resolved[findedIndex].type === type) return 1
    return -1
  } else {
    return 0
  }
}
function haveItemInResolved(item) {
  return findItemInResolved.call(this, item) >= 0
}
export default {
  name: 'IntegrationsResolve',
  data: () => ({
    iterator: 0,
    inResolve: false,
    navSettingsOptions: [
      {
        index: 1,
        text: 'Integrations',
        to: {
          name: 'IntegrationSelect'
        }
      },
      {
        index: 2,
        text: 'Log'
      },
      {
        index: 3,
        text: 'Error Details'
      }
    ],
    resolved: []
  }),
  computed: {
    ...mapGetters('integrations', {
      conflicts: 'getSynchronizationConflicts'
    }),
    ...mapGetters('integrations', {
      integrationInfo: 'getIntegrationInfo'
    }),
    itemBg() {
      const vm = this
      return (index, type) => {
        if (!haveTypedItemInResolved.call(vm, vm.conflicts[index][type], type)) return 'bg-white'
        if (haveTypedItemInResolved.call(vm, vm.conflicts[index][type], type) === 1) return 'isApproved'
        return 'isDeclined'
      }
    }
  },
  filters: {
    formattedNumber(v) {
      const str = Math.trunc(v) + ''
      return str.split('').reverse().join('').replace(/(\d{3})/g, '$1 ').split('').reverse().join('')
    }
  },
  methods: {
    takeItem(index, type) {
      const resolvedItem = this.conflicts[index][type]
      resolvedItem.type = type
      if (!haveItemInResolved.call(this, resolvedItem)) {
        this.resolved.push(resolvedItem)
      } else {
        const findedItemIndex = findItemInResolved.call(this, resolvedItem)
        if (type !== this.resolved[findedItemIndex].type) {
          this.resolved.splice(findedItemIndex, 1, resolvedItem)
        }
      }
    },
    takeAllTypedItems(type) {
      this.resolved = this.conflicts.map(item => {
        return item[type]
      })
    },
    async doResolve() {
      if (this.resolved.length === this.conflicts.length) {
        const payload = {
          system: this.integrationInfo.alias,
          data: {
            inventoryId: this.integrationInfo.warehouse.id,
            items: this.resolved
          }
        }
        this.inResolve = true
        const response = await service.doResolve(payload)
        console.log(response)
        if (response?.data?.error?.type === 200) {
          if (this.$checkEqualityStrings(response.data.data.status, 'SUCCESS')) {
            this.$router.push({ name: 'IntegrationSyncSuccess' })
          } else {
            this.$router.push({ name: 'IntegrationSyncError' })
          }
        } else {
          this.$showError('Error of resolve', response?.data?.error?.message || 'The error has occurred during execution of the operation.')
        }
      }
    }
  },
  created() {
    if (!this.integrationInfo.id) {
      this.$router.push({ name: 'IntegrationAllSyncs' })
    }
  },
  components: {
    CustomCircleProgressBar
  }
}
</script>

<style scoped lang="scss">
  .integration__sync__stepper {
    border: 1px solid rgba(grey, 0.35);
    &__header {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 60px;
      background-color: #f5f5f5;
      box-shadow: none;
      border-bottom: 1px solid rgba(grey, 0.35);
    }
  }
  .resolveErrorName {
    text-transform: uppercase;
    position: absolute;
    top: 50%;
    left: 0;
    z-index: 2;
    transform: translateY(-50%);
    background-color: #f4f4f6;
    padding: 0px 7px;
    border-radius: 3px;
    font-weight: 700;
  }
  .resolveItem {
    border: 1px solid rgba(0, 0, 0, 0.12);
  }
  .resolveItemVariant {
    overflow: hidden;
    &:last-of-type {
      border-left: 1px solid rgba(0, 0, 0, 0.12);
    }
  }
  .isApproved {
    background-color: rgba(#00962a, 0.15);
    transition: ease-in 0.2s;
  }
  .isDeclined {
    background-color: rgba(#d51112, 0.15);
    transition: ease-in 0.2s;
  }
</style>
